
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire001c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire001c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $cuPh8 = parcelRequire("cuPh8");
// Dark/light theme toggle with localStorage persistence + system-preference fallback
(function() {
    const themeToggle = document.getElementById('theme-toggle');
    const themeIcon = document.getElementById('theme-icon');
    const themeColorMeta = document.getElementById('theme-color-meta');
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    // Keep these in sync with the --bg tokens in css/main.css
    const THEME_COLOR_LIGHT = '#008080';
    const THEME_COLOR_DARK = '#05050f';
    function applyTheme(isDark) {
        document.body.classList.toggle('dark-mode', isDark);
        if (themeIcon) // Show the icon for the mode you'd switch TO
        themeIcon.textContent = isDark ? "\u2600\uFE0F" : "\uD83C\uDF19";
        if (themeColorMeta) themeColorMeta.setAttribute('content', isDark ? THEME_COLOR_DARK : THEME_COLOR_LIGHT);
        if (themeToggle) themeToggle.setAttribute('aria-pressed', String(isDark));
    }
    function getInitialTheme() {
        const savedTheme = (0, $cuPh8.readSaved)('theme');
        if (savedTheme === 'dark') return true;
        if (savedTheme === 'light') return false;
        return mediaQuery.matches; // no saved preference → follow the system
    }
    applyTheme(getInitialTheme());
    // Follow system changes only while the user hasn't set a manual preference
    mediaQuery.addEventListener('change', function(e) {
        if (!(0, $cuPh8.readSaved)('theme')) applyTheme(e.matches);
    });
    if (themeToggle) themeToggle.addEventListener('click', function() {
        const isDark = document.body.classList.contains('dark-mode');
        applyTheme(!isDark);
        (0, $cuPh8.save)('theme', isDark ? 'light' : 'dark');
    });
})();


//# sourceMappingURL=JimSucks.1c2221fa.js.map
